import { z } from "zod";

const ADDIN_INACTIVITY_LOGOUT_MINUTES_FLAG ="addin_inactivity_logout_minutes";

const SECONDS_PER_MINUTE = 60;

const MILLISECONDS_PER_SECOND = 1000;

const DEFAULT_ADDIN_SESSION_LIFETIME_SECONDS =7 * 24 * 60 * SECONDS_PER_MINUTE;

const ADDIN_KEY_REFRESHES_PER_LIFETIME =7;

const OrgMetadataWithInactivityLogoutSchema = z.object({
  feature_flags: z.object({
    [ADDIN_INACTIVITY_LOGOUT_MINUTES_FLAG]: z.number().int().positive(),
  }),
});

export function addinSessionLifetimeSeconds(orgMetadata: unknown): number {
  const parsed = OrgMetadataWithInactivityLogoutSchema.safeParse(orgMetadata);
  if (!parsed.success) return DEFAULT_ADDIN_SESSION_LIFETIME_SECONDS;
  return parsed.data.feature_flags[ADDIN_INACTIVITY_LOGOUT_MINUTES_FLAG] * SECONDS_PER_MINUTE;
}

export function addinKeyRefreshIntervalMs(lifetimeSeconds: number): number {
  return Math.floor((lifetimeSeconds * MILLISECONDS_PER_SECOND) / ADDIN_KEY_REFRESHES_PER_LIFETIME);
}
